<template>
  <div class="w-full">
    <skeleton class="mt-3 h-[40px] !w-[100px]" />
    <div>
      <skeleton class="mb-3 mt-6 h-[32px] !w-[254px] md:my-8 md:h-[40px]" />
      <skeleton class="h-[180px] !w-full max-sm:mb-3 md:mb-8 md:h-[280px]" />
    </div>
  </div>
</template>

<script setup></script>
